import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'agl-pt-blocks',
  templateUrl: './pt-blocks.component.html',
  styleUrls: ['./pt-blocks.component.scss']
})
export class PtBlocksComponent implements OnInit {

  @Input() color: string = "orange";

  constructor() { }

  ngOnInit(): void {
  }

}
